/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { useCallback } from 'react'

import { useGeneratedHtmlId } from '@elastic/eui'

import { setSecurityTier, toggleSecurityLine } from '@modules/project-lib/securityProjectTypes'

import { SecurityProductFeatureOptions } from '../project-components/ProjectPage/SecurityProductFeatureOptions'

import type { SecurityProductTier, SecurityProductType } from '../project-user-api/v1/types'

export const SelectSecuritySubType: React.FC<{
  securityProductTypes: SecurityProductType[]
  setSecurityProductTypes: (newProductTypes: SecurityProductType[]) => void
}> = ({ securityProductTypes, setSecurityProductTypes }) => {
  const htmlId = useGeneratedHtmlId()

  const onAddOnToggled = useCallback(
    (toggledProductType: SecurityProductType) => {
      setSecurityProductTypes(toggleSecurityLine(securityProductTypes, toggledProductType))
    },
    [securityProductTypes, setSecurityProductTypes],
  )
  const onProductTierChanged = useCallback(
    (newProductTier: SecurityProductTier) => {
      setSecurityProductTypes(setSecurityTier(newProductTier))
    },
    [setSecurityProductTypes],
  )

  return (
    <SecurityProductFeatureOptions
      htmlId={htmlId}
      projectProductTypes={undefined}
      productTypes={securityProductTypes}
      onProductTierChanged={onProductTierChanged}
      onAddOnToggled={onAddOnToggled}
    />
  )
}
